<template>
  <div class="detail-content" v-if="data">
    <!-- 拼图购 去拼团 -->
    <div class="inGroup" v-if="data.groupBuy && data.groupBuy.groupBuyComm">
      <!-- <div v-if="spellGroupData.length > 0"> -->
      <p
        class="group-title"
      >【拼团购】{{data.groupBuy.groupBuyPeople || '未知'}} 人团，单价只要JPY {{data.groupBuy.groupBuyPrice || '未知' | setNumber}}</p>
      <ul class="group-ul" :class="{active:!down}">
        <li class="group-li" v-for="(item,index) in data.groupOrder_doc">
          <!-- 头像 -->
          <span class="group-pic dg-no">
            <img :src="item.userInfo[0].portrait" alt v-if="item.userInfo">
          </span>
          <!-- 姓名 -->
          <p class="group-member-name">{{item.userInfo[0].nickName}}(团长)</p>
          <!-- 差几人拼团成功 -->
          <div class="group-success-wrap">
            <div class="group-poor-people">
              差
              <span
                class="specialColor"
              >{{data.groupBuy.groupBuyPeople - item.participateNum}}人</span>拼团成功
            </div>
            <div
              class="group-countdown"
            >{{times(item.groupBuyEndTime)}}</div>
          </div>
          <!-- 去拼团 -->
          <router-link class="group-link" :to="{path: '/group-detail', query: {groupOrderNumber: item.groupOrderNumber}}">
             <button class="group-btn">去拼团</button>
          </router-link>
        </li>
      </ul>
      <button
        class="group-more"
        v-if="data.groupOrder_doc.length > 2 "
        @click="checkMore()"
      > {{down ? '查看更多' : '立即收起'}}</button>
      <!-- </div> -->
    </div>
    <!-- 宝贝详情 -->
    <div class="detail-wrap">
      <p class="parameter-title">宝贝详情</p>
      <div class="details-info" v-html="data.comDescri || '暂无数据'"></div>
    </div>
  </div>
</template>
<script>
import api from "@/server";
// import { setInterval } from "timers";
export default {
  data() {
    return {
      current: 0,
      pWidth: "",
      show: false,
      rmb: "",
      usd: "",
      gbp: "",
      // 获取父组件传的id
      params: {
        commId: this.$parent.params.id
      },
      // 倒计时状态
      ticker: null,
      data: {},
      down: false
    };
  },
  props: ["detailList", "price"],
  methods: {
    // 计算时间戳
    times(time) {
      // 这个函数是
      if (time >= 0) {
        let str = "";
        let h = Math.floor(time / 1000 / 60 / 60);
        let m = Math.floor((time / 1000 / 60) % 60);
        let s = Math.floor((time / 1000) % 60);
        h = h < 10 ? "0" + h : h;
        m = m < 10 ? "0" + m : m;
        s = s < 10 ? "0" + s : s;
        str = "剩余 " + h + ":" + m + ":" + s;
        return str;
      } else {
        return "活动已结束";
      }
    },
    // 计算倒计时的时间戳
    beginTimer() {
      this.ticker = setInterval(() => {
        for (let i = 0, len = this.data.groupOrder_doc.length; i < len; i++) {
          const item = this.data.groupOrder_doc[i];
          if (item.groupBuyEndTime > 0) {
            item.groupBuyEndTime = item.groupBuyEndTime - 1000;
          }
        }
      }, 1000);
    },
    // 点击更多查看更多团购
    checkMore() {
     this.down = !this.down;
    }
  },
  destroyed() {
    window.clearInterval(this.ticker);
    this.ticker = null;
  },
  watch: {
    detailList: {
      handler(val) {
        this.data = JSON.parse(JSON.stringify(val));
        this.down = this.data.groupOrder_doc.length > 0 ? true : false;
        if(val) {
          this.beginTimer();
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss">
.detail-content {
  width: 100%;
  height: auto;
  padding: 16px 30px 0;
  box-sizing: border-box;
  background: $bg01;
  .on {
    height: auto;
    max-height: 100000px;
    transition: height 0.5s linear;
  }
  .detail-price-wrap,
  .detail-wrap,
  .detail-parameter-wrap,
  .inGroup {
    width: 100%;
    height: auto;
    background: $fc02;
    padding: 30px;
    box-sizing: border-box;
    border-radius: $br20;
    margin-bottom: 8px;
    box-shadow: $box-shadow3;
  }
  .detail-price-wrap {
    border-radius: 0 0 $br20 $br20;
  }
  .parameter-title {
    font-size: 28px;
    color: $fc09;
    padding: 15px 0;
    border-bottom: 2px solid $bc04;
    margin-bottom: 18px;
  }

  /*商品参数*/
  .detail-parameter-wrap {
    .parameter-p {
      font-size: 24px;
      color: $fc09;
      margin-top: 16px;
      padding-left: 10px;
    }
  }
  /*宝贝详情*/
  .detail-wrap {
    width: 100%;
    height: auto;
    .details-info {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      overflow: hidden;
      word-break: break-word;
      p {
        img {
          max-width: 100% !important;
          min-width: 0 !important;
          height: auto!important;
          text-align: center;
        }
      }
    }
  }
  /*去拼团 拼团购*/
  .inGroup {
    .group-title {
      font-size: 28px;
      color: $fc03;
      line-height: 60px;
    }
    .active{
      max-height: 8888888px!important;
    }
    .group-ul {
      max-height: 270px;
      overflow: hidden;
      .group-li {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 2px solid $bc04;
        padding: 16px 0;
        .group-pic {
          width: 100px;
          height: 100px;
          overflow: hidden;
          margin-right: 30px;
          background: url('../../../../assets/images/no-login.png');
          background-size: 100% 100%;
          border-radius: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
        .group-member-name {
          width: 150px;
          font-size: 28px;
          color: $fc03;
          // flex: 1;
          overflow: hidden;
          @include ellipsis()
        }
        .group-success-wrap {
          font-size: 24px;
          flex: 1;
          text-align: center;
          overflow: hidden;
          .specialColor {
            color: $fc04;
          }
        }
        .group-link{
          display: inline-block;
          .group-btn {
            width: 120px;
            // height: 40px;
            // line-height: 40px;
            padding: 8px 0;
            background: $btn02;
            @include resetButton();
            border-radius: $br30;
            color: $fc02;
            font-size: 24px;
            &:active {
              background: $btnHover02;
            }
          }
        }

      }
    }
    .group-more {
      width: 200px;
      height: 60px;
      line-height: 60px;
      margin: 0 auto;
      background: $bg01;
      @include resetButton();
      color: $fc09;
      text-align: center;
      display: block;
      border-radius: 5px;
      margin-top: 40px;
      font-size: 22px;
      &:active {
        background: $bg06;
      }
    }
  }
}
</style>


